import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './tufts-data-bubble.css.lit';
import { SlotNGController } from '../../controllers/slot-ng-controller';

/**
 * The basic colors that can be background properties.
 * TODO: Update to match the css vars for color
 */
export type BgColor = 'white' | 'medium-blue' | 'dark-green' | 'medium-violet';

/**
 * The TuftsDataBubble component
 * @element tufts-data-bubble
 *
 * @slot data
 * @slot description
 * @slot label
 *
 * @attr bg-color
 * @attr shape
 */
@customElement('tufts-data-bubble')
export class TuftsDataBubble extends OutlineElement {
  ngSlot = new SlotNGController(this);

  static styles: CSSResultGroup = [componentStyles];
  /**
   * The color that the bubble should be, default is white.
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'bg-color',
  })
  bgColor: BgColor = 'white';

  @property({
    type: String,
    reflect: true,
    attribute: 'shape',
  })
  shape = 'circle';

  @state() hasDataSlot: boolean;
  @state() hasDescriptionSlot: boolean;
  @state() hasLabelSlot: boolean;

  firstUpdated(): void {
    this.hasDataSlot = this.ngSlot.exist('data');
    this.hasDescriptionSlot = this.ngSlot.exist('description');
    this.hasLabelSlot = this.ngSlot.exist('label');
  }

  render(): TemplateResult {
    return html`
      <div class="data-bubble__wrapper ${this.bgColor} ${this.shape}">
        ${this.hasDataSlot
          ? html` <div class="data-bubble__data">
              <slot name="data"></slot>
            </div>`
          : nothing}
        ${this.hasDescriptionSlot
          ? html` <div class="data-bubble__description">
              <slot name="description"></slot>
            </div>`
          : nothing}
        ${this.hasLabelSlot
          ? html` <div class="data-bubble__label">
              <slot name="label"></slot>
            </div>`
          : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-data-bubble': TuftsDataBubble;
  }
}
